import { render, staticRenderFns } from "./CollaboratorModal.vue?vue&type=template&id=5fcc7338&"
import script from "./CollaboratorModal.vue?vue&type=script&lang=js&"
export * from "./CollaboratorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports